<template>
  <div class=" is-fullwidth">
    <div class="buttons is-pulled-left" >
        
    <button class="button " v-bind:class="{'is-success': fully_printed == 1}" @click="fully_printed=1">Printed Garments</button>
        <button class="button " v-bind:class="{'is-success': fully_printed == 0}" @click="fully_printed=0">Non Printed Garments</button>
      
      
      
    </div>

    <div class="is-pulled-left mb-2 ml-4">
      <button class="button is-info" @click="showEmailModal=true" style="display:none">
        Send Email
        <span v-if="selectedOrderIDs.length > 0" class="tag is-white ml-2">{{ selectedOrderIDs.length }}</span>
      </button>
    </div>

    <div class="is-pulled-right mb-2">
        <div class="columns">
          
            <div class="column"><input class="input " v-model="search" placeholder="search orders ..." :disabled="loading==true"/></div>
            
        </div>
        
        
    </div>

    
        <p style="clear:both">Displaying {{  this.filteredOrders.length }} orders
        <span v-if="fully_printed == 0"> and {{  filteredTransferredOrders.length  }} transferred orders</span>
        </p>
        <br />
    <!-- Send Email Modal -->
    <div class="modal" :class="{'is-active': showEmailModal}">
      <div class="modal-background" @click="showEmailModal=false"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Send Email</p>
          <button class="delete" aria-label="close" @click="showEmailModal=false"></button>
        </header>
        <section class="modal-card-body">
          <div class="notification is-info is-light" v-if="selectedOrderIDs.length > 0">
            {{ selectedOrderIDs.length }} order(s) selected &mdash; IDs: {{ selectedOrderIDs.join(', ') }}
          </div>
          <div class="notification is-warning is-light" v-else>
            No orders selected. Please select at least one order before sending.
          </div>
          <div class="field">
            <label class="label">Email Type</label>
            <div class="control">
              <div class="select is-fullwidth">
                <select v-model="emailType">
                  <option value="" disabled>Select email type ...</option>
                  <option value="order_confirmation">DTF Orders</option>
                  <option value="dispatch_notice">Offshore Embroidery </option>
                  <option value="delivery_update">Short Orders</option>
                </select>
              </div>
            </div>
          </div>
        </section>
        <footer class="modal-card-foot">
          <button class="button is-success" @click="sendEmail" :disabled="selectedOrderIDs.length === 0">Send Email</button>
          <button class="button" @click="showEmailModal=false">Cancel</button>
        </footer>
      </div>
    </div>

    <table class="table is-hoverable is-fullwidth is-size-7" id="orderstable" >
    	<thead>
        <tr>
    		<th width="30"><input type="checkbox" v-model="selectAllOrders" /></th>
    		<th width="60">&nbsp;</th>
        <th>PO Number</th>
   	 		<th>Customer</th>
          <th>Garment</th>
          <th>Extras</th>
          <th>Range</th>
          <th>Colourway</th>
          <!--<th @click="updateSortOrder('deliverydate')" style="cursor:pointer">Delivery
            <span v-if="order_by === 'deliverydate DESC'">&#8595;</span>
            <span v-if="order_by === 'deliverydate ASC'">&#8593;</span>
          </th>-->
          <th>Order Date</th>
          <th>Delivery</th>
          <th>Qty</th>
          <th width="190">Allocated Location</th>
          <td v-if="fully_printed==0">&nbsp;</td>
          <th >Process</th>
          </tr>
    	</thead>
    	<tbody>
		    <tr v-if="loading === true">
                <td colspan="13" v-if="fully_printed==0"><div class="notification is-info">Loading orders ...</div></td>
                <td colspan="12" v-if="fully_printed==1"><div class="notification is-info">Loading orders ...</div></td>
            </tr>
            <tr v-if="loading == false && filteredOrders.length == 0">
                <td colspan="13" v-if="fully_printed==0"><div class="notification is-warning">There are no orders to show</div></td>
                <td colspan="12" v-if="fully_printed==1"><div class="notification is-warning">There are no orders to show</div></td>
            </tr>
            
            <tr v-for="order in filteredOrders" v-bind:key="order.orderID">
              
         <td><input type="checkbox" :value="order.ponumber" v-model="selectedOrderIDs" /></td>
         <td >
          <a :href="ASP_URL + '/update-order-fully-printed.php?MODE=VIEWORDER&orderID=' + order.orderID " target="_blank">
          <div class="tag is-success" v-if="order.fully_printed == 1">F/P</div>
            <div class="tag is-link" v-if="order.part_printed == 1">P/P</div>
            <div class="tag is-warning" v-if="order.cut_sew == 1">C/S</div></a>
              </td>
               <td ><a :href="ASP_URL + '/createpdforder-internal.php?txtPONumber=' + order.ponumber + '&MODE=VIEW'" target="_blank">{{order.ponumber}}</a></td>
          <td>{{order.clientname}}</td>
          <td>{{order.garmentname}}</td>
          <td><IncomingOrdersExtraTags :order="order" :working="working" @toggleSilicon="toggleSilicon(order)" @toggleDTF="toggleDTF(order)"/></td>
          <td>{{order.range}}</td>
          <td>{{ order.design_colourway }}</td>
          <td>{{order.orderdate}}</td>
          <td>{{order.deliverydate}}</td>
          <td>{{ order.total_qty }}</td>
          <td >
              <div class="buttons" v-if="checkValidGarment(order) == true ">

                <button class="button is-small" @click="updateOrderOffshore(order)" :class="{'is-success' : order.offshore == 1}" :disabled="working==true">Off Shore</button>
                <button class="button is-small" @click="updateOrderIreland(order)" :class="{'is-success' : order.ireland == 1}" :disabled="working==true">Ireland</button>
              </div>
          </td>

          <td v-if="fully_printed==0">
            <button v-if="checkValidGarment(order) == true && 1==2 " class="button is-small" @click="updateCopyToArlene(order)" :class="{'is-warning' : order.copy_to_arlene == 1}" :disabled="working==true">Copy to Arlene</button>
          </td>
          
          
              <td >

                <a v-if="checkValidGarment(order) == false " :href="ASP_URL + '/sales/order/viewdesign?designID=' + order.designID + '&clientID=' +  order.clientID + '&returnUrl=' + APP_URL + '/production/incoming-orders'"><div class="button is-small is-danger" >Garment Invalid</div></a>  
                  
                  <button v-if="checkValidGarment(order) == true " class="button is-small is-info" @click="processOrder(order)" :disabled="working===true" v-show="order.offshore == 1 || order.ireland == 1  ">Process</button>
              </td>
			</tr>
    	</tbody>
    </table>



    <div v-if="fully_printed == 0">
      <h2 class="title">Transferred Orders</h2>

        <table class="table is-hoverable is-fullwidth is-size-7" id="orderstable">
        <thead>
          <tr>
          <th width="30"><input type="checkbox" v-model="selectAllTransferred" /></th>
          <th width="60">&nbsp;</th>
          <th>PO Number</th>
          <th>Customer</th>
            <th>Garment</th>
            <th>Extras</th>
            <th>Range</th>
            <!--<th @click="updateSortOrder('deliverydate')" style="cursor:pointer">Delivery
              <span v-if="order_by === 'deliverydate DESC'">&#8595;</span>
              <span v-if="order_by === 'deliverydate ASC'">&#8593;</span>
            </th>-->
            <th>Order Date</th>
            <th>Delivery</th>
            <th>Qty</th>
            <th width="190">Allocated Location</th>
            <th >Process</th>
            </tr>
        </thead>
        <tbody>
          <tr v-if="loading_transferred === true">
                  <td colspan="11" ><div class="notification is-info">Loading orders ...</div></td>
              </tr>
              <tr v-if="loading_transferred == false && filteredTransferredOrders.length == 0">
                  <td colspan="11" ><div class="notification is-warning">There are no orders to show</div></td>
              </tr>
              
            <tr v-for="order in filteredTransferredOrders" v-bind:key="order.orderID">
                
          <td><input type="checkbox" :value="order.ponumber" v-model="selectedOrderIDs" /></td>
          <td >
            <a :href="ASP_URL + '/update-order-fully-printed.php?MODE=VIEWORDER&orderID=' + order.orderID " target="_blank">
            <div class="tag is-success" v-if="order.fully_printed == 1">F/P</div>
            <div class="tag is-link" v-if="order.part_printed == 1">P/P</div>
            <div class="tag is-warning" v-if="order.cut_sew == 1">C/S</div>
          </a>
                    
                </td>
                <td ><a :href="ASP_URL + '/createpdforder-internal.php?txtPONumber=' + order.ponumber + '&MODE=VIEW'" target="_blank">{{order.ponumber}}</a></td>
            <td>{{order.clientname}}</td>
            <td>{{order.garmentname}}</td>
            <td><IncomingOrdersExtraTags :order="order" :working="working" @toggleSilicon="toggleSilicon(order)" @toggleDTF="toggleDTF(order)"/></td>
            <td>{{order.range}}</td>
            <td>{{order.orderdate}}</td>
            <td>{{order.deliverydate}}</td>
            <td>{{ order.total_qty }}</td>
            <td >
                <div class="buttons" v-if="checkValidGarment(order) == true ">

                  <button class="button is-small" @click="updateOrderOffshore(order)" :class="{'is-success' : order.offshore == 1}" :disabled="working==true">Off Shore</button>
                  <button class="button is-small" @click="updateOrderIreland(order)" :class="{'is-success' : order.ireland == 1}" :disabled="working==true">Ireland</button>
                </div>
            </td>
            
            
                <td >
                  <a v-if="checkValidGarment(order) == false " :href="ASP_URL + '/sales/order/viewdesign?designID=' + order.designID + '&clientID=' +  order.clientID + '&returnUrl=' + APP_URL + '/production/incoming-orders'"><div class="button is-small is-danger" >Garment Invalid</div></a>  
                  
                  <button v-if="checkValidGarment(order) == true " class="button is-small is-info" @click="processOrder(order)" :disabled="working===true" v-show="order.offshore == 1 || order.ireland == 1  ">Process</button>
                </td>
        </tr>
        </tbody>
      </table>
    </div>
    
    
    
  </div>
</template>

<script>


import OrderService from '@/services/OrderService.js';
//import UtilityService from '@/services/UtilityService.js';

import OrderMixin from "@/mixins/OrderMixin.js";
import IncomingOrdersExtraTags from "@/components/Production/IncomingOrdersExtraTags.vue";


export default {
  components: {
    IncomingOrdersExtraTags
  },
  mixins: [OrderMixin],
  data() {
    return {
       errors: [],
      orders: [],
      transferred_orders: [],
      showModal: false,
      selectedOrderID: 0,
      working :false,
      loading: true,
      showEmailModal: false,
      emailType: '',
      selectedOrderIDs: [],
      loading_transferred: true,
      ASP_URL : process.env.VUE_APP_ASP_URL,
      APP_URL : process.env.VUE_APP_URL,
      ranges: [],
      makeuplocations: [],
      order_by: 'deliverydate ASC',
      fully_printed : 1,
      accessToken: '',
      search: ''
    }
  },
   methods: {
    checkValidGarment(order) {
      if(order.garmentname == "Historical Leisurewear")
      {
        return false
      }
      else if(order.sku_range_id > 0 && order.style_id > 0 )
      {
        // Don't check the colourway on this page
        /*if(order.design_colourway == "" || order.design_colourway == "." || order.design_colourway == " ")
        {
          return false
        }
        else{
          return true
        }*/
        return true
      }
      else{
        return false
      }
      
    },
    async toggleSilicon(order)
    {
      var newValue = 0
      if(order.requires_silicon_stripes == 1)
      {
        newValue = 0
      }
      else {
        newValue = 1
      }

      this.working = true
      var formdata = { 
          _method: 'patch',
          requires_silicon_stripes: newValue
        }

        OrderService.updateDesign(this.accessToken, order.designID, formdata)
        .then(() => {
          order.requires_silicon_stripes = newValue
            this.working = false
            //console.log(response)
        }).catch((error) => {
           alert("Something went wrong and the order has not been updated. Please reload and try again")
            console.log("Error:" + JSON.stringify(error.response.data));
            this.working = false
        });
    },
    async toggleDTF(order)
    {
      var newValue = 0
      if(order.requires_dtf == 1)
      {
        newValue = 0
      }
      else {
        newValue = 1
      }

      this.working = true
      var formdata = { 
          _method: 'patch',
          requires_dtf: newValue
        }

        OrderService.updateDesign(this.accessToken, order.designID, formdata)
        .then(() => {
          order.requires_dtf = newValue
            this.working = false
            //console.log(response)
        }).catch((error) => {
           alert("Something went wrong and the order has not been updated. Please reload and try again")
            console.log("Error:" + JSON.stringify(error.response.data));
            this.working = false
        });
    },
      async getOrders() {
        this.loading=true
        this.orders = []


        OrderService.getProductionIncomingOrders(this.accessToken, this.order_by, this.fully_printed, '', '')
        .then(
          (orders => {
            this.$set(this, "orders", orders);
            this.loading=false
          }).bind(this)
        );
      },
      async getTransferredOrders() {
        this.loading_transferred=true
        this.transferred_orders = []


        OrderService.getProductionIncomingOrders(this.accessToken, this.order_by, "", 1, 1) 
        .then(
          (transferred_orders => {
            this.$set(this, "transferred_orders", transferred_orders);
            this.loading_transferred=false
          }).bind(this)
        );
      },
      updateOrderOffshore(order)
      {
        
        if( order.offshore == 1)
        {
          order.offshore = 0
        }
        else{
          order.offshore = 1
          order.ireland = 0
        }
      },

      updateOrderIreland(order)
      {
        if(order.ireland == 1)
        {
          order.ireland = 0
        }
        else{
          order.ireland = 1
          order.offshore = 0
        }
      },
      updateCopyToArlene(order)
      {
        if(order.copy_to_arlene == 1)
        {
          order.copy_to_arlene = 0
        }
        else{
          order.copy_to_arlene = 1
          
        }
      },
    
    sendEmail() {
      if (!this.emailType) {
        alert('Please select an email type.')
        return
      }
      if (this.selectedOrderIDs.length === 0) {
        alert('Please select at least one order.')
        return
      }
      var orderIDString = this.selectedOrderIDs.join(',')
      // TODO: implement email sending logic — orderIDString contains selected IDs
      console.log('Sending email type:', this.emailType, 'for orders:', orderIDString)
      this.showEmailModal = false
      this.emailType = ''
      this.selectedOrderIDs = []
    },
    async processOrder(order) {
        this.working = true
        
        var order_id = order.orderID

        var ready_to_export_scheduler = 0
        if(this.fully_printed == 0 || order.ireland == 1)
        {
          ready_to_export_scheduler = 1
        }

        var formdata = {}
        if(order.copy_to_arlene == 1)
        {
             formdata = { 
              _method: 'patch',
              offshore: order.offshore,
              ireland: order.ireland,
              ready_to_export_scheduler : ready_to_export_scheduler,
              fully_printed: 1
          }; 
        }
        else
        {
            // Doing this separately otherwise all jerseys were being reset to not printed
             formdata = { 
                _method: 'patch',
                offshore: order.offshore,
                ireland: order.ireland,
                ready_to_export_scheduler : ready_to_export_scheduler
               
            }; 
        }
        
        

        OrderService.updateOrder(this.accessToken, order_id, formdata)
        .then(() => {
          order.processed = true
            this.working = false
            //console.log(response)
        }).catch((error) => {
           alert("Something went wrong and the order has not been updated. Please reload and try again")
            console.log("Error:" + JSON.stringify(error.response.data));
            this.working = false
        });
    },
    
    
  },
  computed : {
      selectAllOrders: {
        get() {
          return this.filteredOrders.length > 0 && this.filteredOrders.every(o => this.selectedOrderIDs.includes(o.ponumber))
        },
        set(val) {
          if (val) {
            this.filteredOrders.forEach(o => { if (!this.selectedOrderIDs.includes(o.ponumber)) this.selectedOrderIDs.push(o.ponumber) })
          } else {
            var ids = this.filteredOrders.map(o => o.ponumber)
            this.selectedOrderIDs = this.selectedOrderIDs.filter(id => !ids.includes(id))
          }
        }
      },
      selectAllTransferred: {
        get() {
          return this.filteredTransferredOrders.length > 0 && this.filteredTransferredOrders.every(o => this.selectedOrderIDs.includes(o.ponumber))
        },
        set(val) {
          if (val) {
            this.filteredTransferredOrders.forEach(o => { if (!this.selectedOrderIDs.includes(o.ponumber)) this.selectedOrderIDs.push(o.ponumber) })
          } else {
            var ids = this.filteredTransferredOrders.map(o => o.ponumber)
            this.selectedOrderIDs = this.selectedOrderIDs.filter(id => !ids.includes(id))
          }
        }
      },
      filteredOrders: function () {
       
        let filteredOrders =  this.orders.filter(function(u) {
            if(  u.processed == true) 
            {
              return false
            }
            else
            {
              return true
            }
          })

          const trimmedSearch = this.search ? this.search.trim().toLowerCase() : '';

          if(trimmedSearch != '' && trimmedSearch != null)
          {
            filteredOrders = filteredOrders.filter(row => row.range.toLowerCase().includes(trimmedSearch.toLowerCase()) || row.ponumber.toLowerCase().includes(trimmedSearch.toLowerCase()) || row.garmentname.toLowerCase().includes(trimmedSearch.toLowerCase()))
          }

          return filteredOrders
       
     },
     filteredTransferredOrders: function () {
       
       let filteredTransferredOrders =  this.transferred_orders.filter(function(u) {
           if(  u.processed == true) 
           {
             return false
           }
           else
           {
             return true
           }
         })

         const trimmedSearch = this.search ? this.search.trim().toLowerCase() : '';

         if(trimmedSearch != '' && trimmedSearch != null)
          {
            filteredTransferredOrders = filteredTransferredOrders.filter(row => row.range.toLowerCase().includes(trimmedSearch.toLowerCase()) || row.ponumber.toLowerCase().includes(trimmedSearch.toLowerCase()) || row.garmentname.toLowerCase().includes(trimmedSearch.toLowerCase()))
          }

         return filteredTransferredOrders
      
    }
  },

  // Fetches posts when the component is created.
  created() {
    
    
    this.getAccessToken()
        .then(() => { 
           this.getOrders();

           if(this.fully_printed == 0)
           {
              this.getTransferredOrders()
           }
           
        });
  },
 
  mounted() {
    if (localStorage.incoming_orders_fully_printed) {
      this.fully_printed = localStorage.incoming_orders_fully_printed;
    }
    else{
      this.fully_printed = 1
    } 

    if (localStorage.incoming_orders_search) {
      this.search = localStorage.incoming_orders_search;
    }
    else{
      this.search = ''
    }
      
  },
  watch: {
    fully_printed: function () {
      localStorage.incoming_orders_fully_printed = this.fully_printed
      if(this.accessToken != "")
      {
        this.getOrders()

      }
    },
    search: function () {
      localStorage.incoming_orders_search = this.search
      
    },
  }
}


</script>

